import { MultiLanguageCollection, ModelTypeDecorator } from '@nts/std';
import { SoftwareServiceML } from './software-service-ml';
import { SoftwareServiceMLIdentity } from './software-service-ml.identity';


@ModelTypeDecorator(SoftwareServiceML)
export class SoftwareServiceMLCollection extends MultiLanguageCollection<SoftwareServiceML, SoftwareServiceMLIdentity> {

}
